export default {
    title: "致谢",
    message: "<p>通过选中此框，我承认我是一个 O-I员工和我同意 O-I及其合作伙伴 DXC 及其关联公司存储和处理在本网站上提交的个人信息，以便向我提供所要求的内容。 DXC 及其附属公司需要我提供的联系信息，以便他们可以与我联系并提供与我的订单相关的信息。第三方供应商也将收到我的信息以便向我运送产品。</p><p>有关隐私惯例以及保护和尊重我的隐私的承诺的更多信息，请查看<a href='{privacyPolicyUrl}' target='_blank' rel='noopener'>隐私政策</a></p>",
    submit: "提交",
}